import { render, staticRenderFns } from "./NumPerPageSelect.vue?vue&type=template&id=43b75736&scoped=true"
import script from "./NumPerPageSelect.vue?vue&type=script&lang=ts"
export * from "./NumPerPageSelect.vue?vue&type=script&lang=ts"
import style0 from "./NumPerPageSelect.vue?vue&type=style&index=0&id=43b75736&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b75736",
  null
  
)

export default component.exports